import { useState, type FormEvent } from "react";
import { ExternalLink, Store } from "lucide-react";
import { Button, Field, PageHeader } from "../components/UI";
import { useWeSell } from "../state/WeSellProvider";

export function StorefrontSettings() {
  const { data, saving, editStorefront } = useWeSell();
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState(
    () =>
      data?.storefront ?? {
        slug: "laisemesquita",
        title: "",
        bio: "",
        disclosure: "",
        active: true,
      },
  );
  if (!data) return null;
  const publicUrl = `${window.location.origin}/v/${form.slug}`;
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    await editStorefront(form);
    setSaved(true);
    window.setTimeout(() => setSaved(false), 1800);
  };
  return (
    <>
      <PageHeader
        eyebrow="Página pública"
        title="Minha vitrine"
        description="Uma página simples para colocar na bio e transformar os códigos dos vídeos em cliques rastreáveis."
        action={
          <a
            className="button button--secondary"
            href={`/v/${form.slug}`}
            target="_blank"
            rel="noreferrer"
          >
            Ver vitrine <ExternalLink size={17} />
          </a>
        }
      />
      <div className="storefront-layout">
        <form className="panel form-grid settings-form" onSubmit={submit}>
          <Field label="Título">
            <input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
            />
          </Field>
          <Field label="Endereço" helper={publicUrl}>
            <div className="slug-input">
              <span>/v/</span>
              <input
                value={form.slug}
                onChange={(e) =>
                  setForm({
                    ...form,
                    slug: e.target.value
                      .toLowerCase()
                      .replace(/[^a-z0-9-]/g, ""),
                  })
                }
                required
              />
            </div>
          </Field>
          <Field label="Bio">
            <textarea
              rows={4}
              value={form.bio}
              onChange={(e) => setForm({ ...form, bio: e.target.value })}
            />
          </Field>
          <Field label="Aviso de afiliada">
            <textarea
              rows={3}
              value={form.disclosure}
              onChange={(e) => setForm({ ...form, disclosure: e.target.value })}
              required
            />
          </Field>
          <label className="toggle-row">
            <input
              type="checkbox"
              checked={form.active}
              onChange={(e) => setForm({ ...form, active: e.target.checked })}
            />
            <span>
              <strong>Vitrine publicada</strong>
              <small>Desative para ocultar a página inteira.</small>
            </span>
          </label>
          <div>
            <Button type="submit" loading={saving}>
              Salvar vitrine
            </Button>
            {saved ? <span className="inline-success">Salvo</span> : null}
          </div>
        </form>
        <aside className="phone-preview" aria-label="Prévia da vitrine">
          <div className="phone-preview__screen">
            <span className="brand-mark">
              <Store size={22} />
            </span>
            <h2>{form.title || "Sua vitrine"}</h2>
            <p>{form.bio}</p>
            <div className="preview-search">Buscar código ou produto</div>
            {data.products
              .filter((product) => product.published)
              .slice(0, 3)
              .map((product) => (
                <div className="preview-product" key={product.id}>
                  <img src={product.imageUrl} alt="" />
                  <div>
                    <strong>{product.shortCode}</strong>
                    <span>{product.name}</span>
                  </div>
                </div>
              ))}
            <small>{form.disclosure}</small>
          </div>
        </aside>
      </div>
    </>
  );
}
